<template>
  <div
    class="show cmp-dev-theme-switcher full-width text-center q-pa-sm"
  >
    <div class="content">
      Theme: &nbsp;
      <button class="theme-button q-ma-xs" @click="switchTheme(Theme.CARY)">
        CARY
      </button>
      <button class="theme-button q-ma-xs" @click="switchTheme(Theme.LOOPIA)">
        LOOPIA
      </button>
      <button class="theme-button q-ma-xs" @click="switchTheme(Theme.ACTIVE_24)">
        ACTIVE24
      </button>
    </div>
  </div>
</template>

<script lang="ts">
import { Component, Vue } from 'vue-property-decorator';
import { Theme } from '@loopia-group/services';

@Component({})
export default class ThemeSwitcher extends Vue {
  Theme = Theme;

  switchTheme = (theme: string) => {
    // @ts-ignore
    window.switchTheme(theme);
  };
}
</script>

<style lang="scss" scoped>
.cmp-dev-theme-switcher {
  position: fixed;
  bottom: 0;
  z-index: 10000;
  color: $ws-white;

  &.show {
    background: rgba($color: #000000, $alpha: 0.5);
  }

  .theme-button {
    border: 1px solid $ws-white;
    border-radius: 4px;
    color: $ws-white;
    padding: 4px 8px;
  }
}
</style>
